import HTTP from './http'
const BASE_URL = '/companyjob'
const PUBLIC_BASE_URL = '/viewjob'

import Store from '@/store'
const currentUsersCompanyKey = () =>
  Store.getters['user/accountInfo'].company && Store.getters['user/isShipper']
    ? Store.getters['user/accountInfo'].company.companyKey
    : null

const currentCarrierAccountKey = () =>
  Store.getters['user/accountInfo'].carrier && Store.getters['user/isCarrier']
    ? Store.getters['user/accountInfo'].accountKey
    : null

export default {
  async list({ companyKey, createdByAccountKey, factoringProviderKey = null, accountKey }) {
    const params = {
      factoringProviderKey,
      companyKey: companyKey || currentUsersCompanyKey(),
      createdByAccountKey: createdByAccountKey || null,
      accountKey: accountKey || currentCarrierAccountKey()
    }

    const response = await HTTP.get(`${BASE_URL}/list`, { params })
    return response.data.data
  },

  async getByKey(jobKey) {
    const params = {
      companyJobKey: jobKey
    }
    const response = await HTTP.get(BASE_URL, { params })
    return response.data
  },

  /**
   * Similar to `getByKey`, but does not require an auth key and returns only public information
   *
   * @param {String} jobKey The UUID of the companyJob in question
   * @returns {Promise<*>}
   */
  async getPublicInformationByKey(jobKey) {
    const params = {
      companyJobKey: jobKey
    }
    const response = await HTTP.get(PUBLIC_BASE_URL, { params })
    return response.data.data
  },

  async create(jobDetails) {
    // never EVER send the "status" text.
    const response = await HTTP.post(BASE_URL, jobDetails)
    return response.data
  },

  async update(jobDetails) {
    // never EVER send the "status" text.
    delete jobDetails.companyJobStatus
    const response = await HTTP.put(BASE_URL, jobDetails)
    return response.data
  },

  async delete(companyJobKey) {
    const params = {
      companyJobKey
    }
    await HTTP.delete(BASE_URL, { params })
  },

  async deleteJobPoint(companyJobPointKey) {
    const params = {
      companyJobPointKey
    }
    await HTTP.delete(BASE_URL, { params })
  },

  async deleteFreight(companyJobFreightKey) {
    const params = {
      companyJobFreightKey
    }
    await HTTP.delete(BASE_URL, { params })
  },

  async getExecutionLog({ companyJobKey, companyKey, factoringProviderKey, accountKey }) {
    const params = {
      companyJobKey,
      companyKey,
      factoringProviderKey,
      accountKey
    }

    // if there is a factoring key, then don't send the company key
    if (factoringProviderKey) {
      delete params.companyKey
    }
    const response = await HTTP.get(`${BASE_URL}/executionlog`, { params })
    return response.data.data
  }
}
